let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cpB9q")).then(() => parcelRequire('9glos'));